import React, { ReactNode } from 'react';
import classNames from 'classnames';

import Avatar from '../../atoms/avatar/Avatar';
import Badge, { BadgeProps } from '../../atoms/badge/Badge';
import Text from '../../atoms/text/Text';

export interface UserInfoCardProps {
  id?: string;
  title?: string;
  subtitle?: string;
  subtitle2?: string;
  imageIcon?: ReactNode;
  imageURL?: string;
  avatarName?: string;
  icon?: ReactNode;
  badge?: BadgeProps;
  compact?: boolean;
  weight?:
    | 'bolder'
    | 'bold'
    | 'semibold'
    | 'medium'
    | 'normal'
    | 'light'
    | 'lighter';
  color?:
    | 'primary'
    | 'secondary'
    | 'danger'
    | 'warning'
    | 'success'
    | 'info'
    | 'dark'
    | 'light'
    | 'white'
    | 'title'
    | 'subtitle1'
    | 'subtitle2'
    | 'subtitle3'
    | string;
  className?: string;
  onClick?: (id?: string) => void;
}

const UserInfoCard = ({
  id,
  title,
  subtitle,
  subtitle2,
  icon,
  imageURL,
  imageIcon,
  avatarName,
  badge,
  compact = true,
  color = 'dark',
  weight = 'normal',
  className,
  onClick,
}: UserInfoCardProps) => {
  return (
    <div
      className={classNames(
        'd-flex justify-content-between gap-6',
        {
          'align-items-center': badge,
        },
        className,
      )}
      onClick={() => onClick && onClick(id)}
    >
      <div className="d-flex align-items-center gap-6">
        {imageIcon ? (
          <div className="bg-white rounded-5 p-6 shadow-sm border">
            {imageIcon}
          </div>
        ) : null}
        {avatarName || imageURL ? (
          <Avatar size="xs" name={avatarName} imageURL={imageURL} />
        ) : null}
        <div className="d-flex flex-column">
          <Text
            weight={weight}
            size="sm"
            color={color}
            className={classNames({
              'text-nowrap': compact,
            })}
          >
            {title}
          </Text>
          {subtitle && (
            <Text
              size="sm"
              color="subtitle1"
              className={classNames({
                'text-nowrap': compact,
              })}
            >
              {subtitle}
            </Text>
          )}
          {subtitle2 && (
            <Text size="xs" color="subtitle3">
              {subtitle2}
            </Text>
          )}
        </div>
      </div>
      {icon && icon}
      {badge && <Badge {...badge} />}
    </div>
  );
};

export default UserInfoCard;
